import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';
import { withDefaultSort } from '../../utils/utility';

export const ACTION = {
  LIST: 'LIST_LIGHTINGSET',
  GET: 'GET_LIGHTINGSET',
  CREATE: 'CREATE_LIGHTINGSET',
  EDIT: 'EDIT_LIGHTINGSET',
  DELETE: 'DELETE_LIGHTINGSET',
  DUPLICATE: 'DUPLICATE_LIGHTINGSET',
  CLEAR_ERROR: 'CLEAR_ERROR_LIGHTINGSET',
  ADD_LUMINAIRE: 'ADD_LUMINAIRE_LIGHTING_SET',
  ADD_LUMINAIRE_TOBECREATED: 'ADD_LUMINAIRE_TOBECREATED',
  ADD_BALLAST_TOBECREATED: 'ADD_BALLAST_TOBECREATED',
  EDIT_BALLAST_TOBECREATED: 'EDIT_BALLAST_TOBECREATED',
  REMOVE_BALLAST_TOBECREATED: 'REMOVE_BALLAST_TOBECREATED',
  EDIT_LUMINAIRE: 'EDIT_LUMINAIRE_LIGHTING_SET',
  REMOVE_LUMINAIRE: 'REMOVE_LUMINAIRE_LIGHTING_SET',
  REMOVE_LUMINAIRE_TOBECREATED: 'REMOVE_LUMINAIRE_TOBECREATED',
  ADD_BALLAST: 'ADD_BALLAST_LIGHTING_SET',
  EDIT_BALLAST: 'EDIT_BALLAST_LIGHTING_SET',
  EDIT_LUMINAIRE_TOBECREATED: 'EDIT_LUMINAIRE_TOBECREATED',
  REMOVE_BALLAST: 'REMOVE_BALLAST_LIGHTING_SET',
  CLEAR_LIGHTING_SET: 'CLEAR_LIGHTING_SET',
};

export const clearErrorLightingSet = () => {
  return {
    type: ACTION.CLEAR_ERROR,
  };
};

export const searchLightingSetByText = (text, page = 0, excludeZoneId = null) => {
  const pageSize = Constants.DATA_TABLE_PAGE_SIZE;
  const sorted = withDefaultSort([]);
  const filtered = text;
  const isPublic = null;
  return searchLightingSet(pageSize, page, sorted, filtered, isPublic, excludeZoneId);
};

const searchLightingSet = (pageSize, page, sorted, filtered, isPublic, excludeZoneId = null) => {
  const zoneParams = excludeZoneId && { not__zone_id: excludeZoneId };
  return RestClient.request({
    method: 'get',
    url: Constants.API_LIGHTING_SET,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
        : null,
      is_public: isPublic,
      ...zoneParams,
    },
  });
};

export const listLightingSetItems = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchLightingSet(pageSize, page, sorted, filtered, isPublic)
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const createLightingSet = (name, description, image, bulb_list, ballast_list) => {
  const formData = new FormData();
  formData.set('name', name);
  formData.set('bulb_list', JSON.stringify(bulb_list));
  formData.set('ballast_list', JSON.stringify(ballast_list));
  if (typeof description === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `acpu_${new Date().valueOf()}`);
  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_LIGHTING_SET,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const getLightingSet = id => {
  return {
    type: ACTION.GET,
    payload: RestClient.request({
      method: 'get',
      url: `${Constants.API_LIGHTING_SET}${id}/`,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editLightingSet = (id, name, description, image) => {
  const formData = new FormData();
  if (name) formData.set('name', name);
  if (typeof(description) === 'string') formData.set('description', description);
  if (image) formData.set('image', image, `equipment_${new Date().valueOf()}`);

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_LIGHTING_SET}${id}/`,
      data: formData,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const deleteLightingSet = lightingsetId => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_LIGHTING_SET}${lightingsetId}/`,
    })
      .then(() => ({ id: lightingsetId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const duplicateLightingSet = (id, name) => {
  const data = { new_name: name };
  return {
    type: ACTION.DUPLICATE,
    payload: RestClient.request({
      method: 'post',
      url: `${Constants.API_LIGHTING_SET}${id}/copy/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const addLightingSetLuminaire = (lightingSetId, bulbId, quantity) => {
  const data = {
    lighting_set_id: lightingSetId,
    bulb_id: bulbId,
    quantity: quantity,
  };

  return {
    type: ACTION.ADD_LUMINAIRE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_LIGHTING_SET_LUMINAIRE,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addToBeCreatedLuminaire = (quantity, luminaire, tobeCreatedluminairearry) => {
  if (tobeCreatedluminairearry.length > 0 ){
    let existed_obj = tobeCreatedluminairearry.filter(rel => rel.bulb.id === luminaire.id)
    if (existed_obj.length > 0){
      return {
        type: ACTION.ADD_LUMINAIRE_TOBECREATED,
        payload: Promise.reject({detail: "The luminaire name: " + existed_obj[0].bulb.name + " is already added into list!"})
      };
    }
  }
  const data = {
      quantity:quantity,
      bulb:luminaire,
  };
  return {
    type: ACTION.ADD_LUMINAIRE_TOBECREATED,
    payload: Promise.resolve(data)
  };
};

export const editLightingSetLuminaire = (lightingSetLuminaireId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT_LUMINAIRE,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_LIGHTING_SET_LUMINAIRE}${lightingSetLuminaireId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editTobeCreatedLuminaire = (id, quantity) => {
  const data = {
      id: id,
      quantity: quantity,
  };
  return {
    type: ACTION.EDIT_LUMINAIRE_TOBECREATED,
    payload: Promise.resolve(data)
  };
};

export const removeLightingSetLuminaire = (lightingSetLuminaireId, lightingSetId) => {
  return {
    type: ACTION.REMOVE_LUMINAIRE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_LIGHTING_SET_LUMINAIRE}${lightingSetLuminaireId}/`,
    })
      .then(() => ({ id: lightingSetLuminaireId, lighting_set_id: lightingSetId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeTobeCreatedLuminaire = (id) => {
  const data = {
      id: id,
  };
  return {
    type: ACTION.REMOVE_LUMINAIRE_TOBECREATED,
    payload: Promise.resolve(data)
  };
};

export const addLightingSetBallast = (lightingSetId, ballastId, quantity) => {
  const data = {
    lighting_set_id: lightingSetId,
    ballast_id: ballastId,
    quantity: quantity,
  };

  return {
    type: ACTION.ADD_BALLAST,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_LIGHTING_SET_BALLAST,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addTobeCreatedBallast = (quantity, ballast, tobeCreatedballastarry) => {
  if (tobeCreatedballastarry.length > 0 ){
    let existed_obj = tobeCreatedballastarry.filter(rel => rel.ballast.id === ballast.id)
    if (existed_obj.length > 0){
      return {
        type: ACTION.ADD_BALLAST_TOBECREATED,
        payload: Promise.reject({detail: "The ballast name: " + existed_obj[0].ballast.name + " is already added into list!"})
      };
    }
  }
  const data = {
      quantity:quantity,
      power_required: 0,
      ballast: ballast,
  };
  return {
    type: ACTION.ADD_BALLAST_TOBECREATED,
    payload: Promise.resolve(data)
  };
};


export const editLightingSetBallast = (lightingSetBallastId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT_BALLAST,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_LIGHTING_SET_BALLAST}${lightingSetBallastId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const editTobeCreatedBallast = (id, quantity) => {
  const data = {
      id: id,
      quantity: quantity,
  };
  return {
    type: ACTION.EDIT_BALLAST_TOBECREATED,
    payload: Promise.resolve(data)
  };
};

export const removeLightingSetBallast = (lightingSetBallastId, lightingSetId) => {
  return {
    type: ACTION.REMOVE_BALLAST,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_LIGHTING_SET_BALLAST}${lightingSetBallastId}/`,
    })
      .then(() => ({ id: lightingSetBallastId, lighting_set_id: lightingSetId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const removeTobeCreatedBallast = (id) => {
  const data = {
      id: id,
  };
  return {
    type: ACTION.REMOVE_BALLAST_TOBECREATED,
    payload: Promise.resolve(data)
  };
};

export const clearTobeCreatedLightingSet = () => {
  
  return {
    type: ACTION.CLEAR_LIGHTING_SET,
    payload: Promise.resolve()
  };
};


// WEBPACK FOOTER //
// ./src/redux/luminaire/lightingset_actions.js